import { makeJwtProvider } from 'modules/authentication/infra/providers';
import { makeHTTPProvider, makeStorageProvider } from 'shared/infra/providers';

import SyncUserSessionUseCase from './implementations/SyncUserSessionUseCase';

let instance: SyncUserSessionUseCase | null = null;

export default function makeSyncUserSessionUseCase() {
  if (!instance) {
    const storageProvider = makeStorageProvider();
    const httpProvider = makeHTTPProvider();
    const jwtProvider = makeJwtProvider();

    instance = new SyncUserSessionUseCase(
      storageProvider,
      httpProvider,
      jwtProvider,
    );
  }

  return instance;
}
